export default __webpack_public_path__ + "static/experienceImg5-29f7e76dc9bf8e9fff9eddff1a4183a9.webp";